export const ALGOLIA_APPLICATION_ID = 'LKSW35EKDJ&x';

export const ALGOLIA_API_KEY = 'fc8f3496024d902ef0991aa3b8475680';
